import SimpleWorkClientRepresentativeAPIResponse from "work/entities/entity-client-representative/api/response-contracts/simple-work-client-representative-api-response";
import SimpleWorkTeamAPIResponse from "work/values/team/api/response-contracts/simple-work-team-api-response";
import WorkProposalAPIResponse from "work/entities/proposal/api/response-contracts/work-proposal-api-response";

export default class SimpleWorkProposalAPIResponse extends WorkProposalAPIResponse {
    declare client: SimpleWorkClientRepresentativeAPIResponse;
    declare team: SimpleWorkTeamAPIResponse;
    declare supersededBy?: SimpleWorkProposalAPIResponse;
}
